function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#12002D",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.035 3.667A2.667 2.667 0 013.702 1h8a2.667 2.667 0 012.666 2.667v8a2.667 2.667 0 01-2.666 2.666h-8a2.667 2.667 0 01-2.667-2.666v-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.368 7a1.667 1.667 0 100-3.333 1.667 1.667 0 000 3.333zM9.386 8.08l-5.684 6.253h8.18a2.487 2.487 0 002.486-2.486c0-.311-.116-.61-.326-.84l-2.687-2.93a1.333 1.333 0 00-1.97.004v0z"
}))));